module.exports = __webpack_public_path__ + "img/balloon.5ec845d5.svg";